<template>
    
    <v-container fluid class="down-top-padding">
        <v-overlay :value="overlay">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>
        <v-row cols="12" lg="12">
            <v-col cols="12" lg="12">
                <v-card color="info" dark>
                    <v-card-actions class="pa-6">
                        <v-row class="indicadores-header" cols="12" lg="12">
                            <v-col class="indicadores-header-logo" cols="12" sm="12" md="5" lg="4" style="background-color: #1e88e5;padding: 0px;" align="center"
                            justify="center">
                            <img src="../assets/images/logo-png.png" class="indicadores-logo" />
                            </v-col>
                            <v-col cols="12" sm="12" md="7" lg="8" style="background-color: #1e88e5;" align="center"
                                justify="center">
                                <h1>RESUMEN DE INDICADORES</h1>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" lg="12">
                <v-dialog
                    v-model="dialog2"
                    persistent
                    max-width="600px"
                    >
                    <v-card>
                        <v-card-title class="primary white--text">
                        <span class="text-h5">Filtros</span><v-icon dark>mdi-tune</v-icon>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="red"
                            dark
                            @click="dialog2 = false"
                            style="margin-top: -30px;margin-right: -25px;">
                            CERRAR
                        </v-btn>
                        </v-card-title>
                        <v-card-text>
                        <br>                       
                        <v-divider></v-divider>
                        <v-container>
                             <h2>Ambito</h2>
                            <v-row>
                                <v-radio-group v-model="ambito" row @change="updateAmbito">
                                    <v-radio label="Administrativo" :value="1"></v-radio>
                                    <v-radio label="Geografico" :value="2"></v-radio>
                                    <v-radio label="RIS" :value="3"></v-radio>
                                    <v-radio label="DISA" :value="4"></v-radio>
                                    <v-radio label="CLAS" :value="5"></v-radio>
                                </v-radio-group>
                            </v-row>
                        </v-container>
                        <v-divider></v-divider>
                        <v-container>
                            <h2>Curso de Vida / Estrategia</h2>
                            <v-row>
                                <v-radio-group v-model="tipoBusqueda" row @change="updateTipoBusqueda">
                                    <v-radio label="Curso de Vida" :value="1"></v-radio>
                                    <v-radio label="Estrategia" :value="2"></v-radio>
                                </v-radio-group>
                            </v-row>
                        </v-container>
                        <v-divider></v-divider>
                        <v-container v-if="tipoBusqueda == 1">
                            <h2>Paquete Integral</h2>
                            <v-row>
                                <v-checkbox
                                    v-model="paqueteIntegral"
                                    label="Solo Paquete Integral" @change="updatePaquete"
                                    >
                                </v-checkbox>
                            </v-row>
                        </v-container>
                        </v-card-text>
                        <v-card-actions>
                        </v-card-actions>
                    </v-card>
                    </v-dialog>
                <v-dialog v-model="dialog">
                    <v-card v-if="ficha != null">
                        <v-card-title class="text-right">
                            Ficha de Indicador
                            <v-btn
                                color="red"
                                dark
                                @click="dialog = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-card-text v-if="ficha != ''">
                            <table style="width:100%; border:1px solid">
                                <tr>
                                    <td style="padding:10px; text-align:center; border:1px solid"><b>NOMBRE DEL INDICADOR</b></td>
                                    <td colspan="6" style="border:1px solid; padding:10px">{{this.ficha.NOMBRE_FICHA}}</td>
                                </tr>
                                <tr>
                                    <td style="padding:10px; text-align:center; border:1px solid"><b>PROCESO</b></td>
                                    <td colspan="6" style="border:1px solid; padding:10px">{{this.ficha.DESCRIPCION_FICHA}}</td>
                                </tr>
                                <tr>
                                    <td style="padding:10px; text-align:center; border:1px solid"><b>FORMULA</b></td>
                                    <td colspan="6" style="border:1px solid; padding:10px">{{this.ficha.FORMULA_FICHA}}</td>
                                </tr>
                                <tr>
                                    <td style="padding:10px; text-align:center; border:1px solid"><b>NUMERADOR</b></td>
                                    <td style="padding:10px;border:1px solid;">{{this.ficha.NUMERADOR}}</td>
                                    <td style="padding:10px; text-align:center; border:1px solid">META</td>
                                    <td style="padding:10px; text-align:center; border:1px solid">100%</td>
                                    <td style="padding:10px; text-align:center; border:1px solid"><b>CLASIFICACIÒN</b></td>
                                    <td style="padding:10px; text-align:center; border:1px solid" colspan="2"><b>RANGO</b></td>
                                </tr>
                                <tr>
                                    <td style="padding:10px; text-align:center; border:1px solid"><b>DENOMINADOR</b></td>
                                    <td style="padding:10px;border:1px solid">{{this.ficha.DENOMINADOR}}</td>
                                    <td style="padding:10px; text-align:center; border:1px solid"><b>FRECUENCIA DE MEDICIÒN</b></td>
                                    <td style="padding:10px; text-align:center; border:1px solid">{{this.ficha.FRECUENCIA_MEDICION}}</td>
                                    <td style="background-color: green; text-align:center; border:1px solid">SATISFACTORIO</td>
                                    <td style="padding:10px; text-align:center; border:1px solid">></td>
                                    <td style="padding:10px; text-align:center; border:1px solid">80%</td>
                                </tr>
                                <tr>
                                    <td style="padding:10px; text-align:center; border:1px solid"><b>UNIDAD</b></td>
                                    <td style="padding:10px;border:1px solid">{{this.ficha.UNIDAD}}</td>
                                    <td style="padding:10px; text-align:center; border:1px solid"><b>TIPO INDICADOR</b></td>
                                    <td style="padding:10px; text-align:center; border:1px solid">{{this.ficha.TIPO_INDICADOR}}</td>
                                    <td style="background-color: yellow; text-align:center; border:1px solid">ACEPTABLE</td>
                                    <td style="padding:10px; text-align:center; border:1px solid">70%</td>
                                    <td style="padding:10px; text-align:center; border:1px solid">60%</td>
                                </tr>
                                <tr>
                                    <td style="padding:10px; text-align:center; border:1px solid"><b>RESPONSABLE DE MEDICIÓN</b></td>
                                    <td style="padding:10px;border:1px solid">{{this.ficha.RESPONSABLE_FICHA}}</td>
                                    <td style="padding:10px; text-align:center; border:1px solid"><b>VIGENCIA</b></td>
                                    <td style="padding:10px; text-align:center; border:1px solid">2022</td>
                                    <td style="background-color: red; text-align:center; border:1px solid">CRITICO</td>
                                    <td style="padding:10px; text-align:center; border:1px solid"></td>
                                    <td style="padding:10px; text-align:center; border:1px solid">60%</td>
                                </tr>
                                <tr>
                                    <td colspan="7" style="width:200px;padding:10px; border:1px solid"><b>OBSERVACIONES:</b> {{this.ficha.OBSERVACIONES_FICHA}}</td>
                                </tr>
                            </table>
                        </v-card-text>
                        <v-card-text v-else>
                            No tiene ficha que mostrar
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialog1" v-if="renderComponent">
                    <v-col cols="12" lg="12" v-if="datosIndicador != null">
                        <v-card class="mb-7">
                            <v-card-title class="text-right">
                            
                            <v-row
                                no-gutters
                            >
                            </v-row>
                            <v-btn
                                color="red"
                                dark
                                @click="dialog1 = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-title>
                            <v-card-text>
                                <HMultiple v-if="datosIndicador != null" :serie="datosIndicador.series" :denominador="datosIndicador.denominador" :numerador="datosIndicador.numerador" :avance="datosIndicador.avance" :titulo="tituloIndicadorGrafico"></HMultiple>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-dialog>
                <v-card>
                    <v-card-text class="pa-5 border-bottom">
                        <v-row v-if="ambito === 1 ">
                            <v-col cols="12" sm="6" md="4" lg="4" style="padding: 0px 12px;">
                                <v-autocomplete :items="redes" label="Red" v-model="red"  @change="updateRed" placeholder="Todas las redes" item-text="Nombre" item-value="Id" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="4" style="padding: 0px 12px;">
                                <v-autocomplete :items="microredes" label="MicroRed" v-model="microred" placeholder="Todas las microredes" @change="updateMicroRed" item-text="Nombre" item-value="Id" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="4" style="padding: 0px 12px;">
                                <v-autocomplete :items="establecimientos" label="Establecimiento" placeholder="Todos los establecimientos" @change="updateEstablecimiento" v-model="establecimiento"  item-text="Nombre" item-value="Id" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row v-if="ambito === 2 ">
                            <v-col cols="12" sm="6" md="4" lg="4" style="padding: 0px 12px;">
                                <v-autocomplete :items="provincias" v-model="provincia" label="Provincia" item-text="name" item-value="id" @change="updateProvincia" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="4" style="padding: 0px 12px;">
                                <v-autocomplete :items="distritos" v-model="distrito" label="Distrito" item-text="NOMBRE" item-value="ID_DISTRITO" @change="updateDistrito" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="4" style="padding: 0px 12px;">
                                <v-autocomplete :items="establecimientos" label="Establecimiento" placeholder="Todos los establecimientos" @change="updateEstablecimiento" v-model="establecimiento"  item-text="Nombre" item-value="Id" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row v-if="ambito === 3 ">
                            <v-col cols="12" sm="6" md="3" lg="3" style="padding: 0px 12px;">
                                <v-autocomplete :items="riss" v-model="ris" label="RIS" item-text="label" item-value="value" @change="updateRis" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="3" style="padding: 0px 12px;">
                                <v-autocomplete :items="zonasSanitarias" v-model="zonaSanitaria" label="Zona Sanitaria" item-text="label" item-value="value" @change="updateZonaSanitaria" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="3" style="padding: 0px 12px;">
                                <v-autocomplete :items="puertasEntrada" v-model="puertaEntrada" label="Puerta de Entrada" item-text="label" item-value="value" @change="updatePuertaEntrada" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="3" style="padding: 0px 12px;" v-if="vinculados.length > 0">
                                <v-autocomplete :items="vinculados" v-model="vinculado" label="Establecimiento Vinculado" item-text="label" item-value="value" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row v-if="ambito === 4 ">
                            <v-col cols="12" sm="6" md="3" lg="3" style="padding: 0px 12px;">
                                <v-autocomplete :items="subregiones" v-model="subregion" label="SubRegion" item-text="Nombre" item-value="Id" @change="updateSubRegion" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="3" style="padding: 0px 12px;">
                                <v-autocomplete :items="redesSubregion" v-model="redSubregion" label="Red" item-text="Nombre" item-value="Id" @change="updateRedSubRegion" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="3" style="padding: 0px 12px;">
                                <v-autocomplete :items="microRedesSubRegion" v-model="microredSubregion" label="MicroRed" item-text="Nombre" item-value="Id" @change="updatemicroredSubregion" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="3" style="padding: 0px 12px;">
                                <v-autocomplete :items="establecimientosSubRegion" v-model="establecimientoSubRegion" label="Establecimiento" item-text="Nombre" item-value="Id" @change="updateEstablecimientoSubregion" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row v-if="ambito === 5 ">
                            <v-col cols="12" sm="6" md="4" lg="4" style="padding: 0px 12px;">
                                <v-autocomplete :items="redesClas" label="Red" v-model="redClas"  @change="updateRedClas" placeholder="Todas las redes" item-text="red" item-value="red" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="4" style="padding: 0px 12px;">
                                <v-autocomplete :items="clases" v-model="clas" label="Class" item-text="clas_pertenece" item-value="clas_pertenece" @change="updateClas" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="4" style="padding: 0px 12px;">
                                <v-autocomplete :items="establecimientosClas" v-model="establecimientoClas" label="EstablecimientoClas" item-text="nombre" item-value="renipress" @change="updateEstablecimientoClas" multiple dense  outlined clearable required></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="3" lg="3" style="padding: 0px 12px;">
                                <v-autocomplete :items="anios" v-model="anio" label="Año" @change="updateAnio" dense  outlined required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="3" style="padding: 0px 12px;">
                                <v-autocomplete :items="meses" v-model="mes" label="Mes" item-text="Nombre" item-value="Id" @change="updateMeses" multiple clearable dense  outlined required>
                                    <template v-slot:selection="{ item, index }">
                                        <v-chip v-if="index === 0">
                                        <span>{{ item.Nombre }}</span>
                                        </v-chip>
                                        <span
                                        v-if="index === 1"
                                        class="grey--text caption"
                                        >(+{{ mes.length - 1 }} Meses)</span>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="2" style="padding: 0px 12px;" v-if="tipoBusqueda==1">
                                <v-autocomplete :items="cursosVidas" v-model="cursoVida" label="Curso de Vida" @change="updateCursoVida" item-text="name" item-value="id" dense  outlined required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="2" style="padding: 0px 12px;" v-if="tipoBusqueda==2">
                                <v-autocomplete :items="estrategias" v-model="estrategia" label="Estrategia" @change="updateEstrategia" item-text="name" item-value="id" dense  outlined required></v-autocomplete>
                            </v-col>
                            <v-col v-show="cursoVida === 2" cols="12" sm="6" md="3" lg="2" v-if="tipoBusqueda==1" style="padding: 0px 12px;">
                                <v-autocomplete :items="gruposEtareos" v-model="grupoEtareo" label="Grupo Etareo" item-text="name" item-value="id" @change="updateSubCursoVida" dense  outlined required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="2" style="padding: 0px 12px;">
                                <v-btn
                                    color="primary"
                                    @click="getIndicadorBoton"
                                    block
                                    >
                                    Buscar
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="2">
                                <v-btn
                                    text
                                    small
                                    color="primary"
                                    dark
                                    outlined style="mt-1"
                                    @click="mostrarFiltros"
                                    block
                                    >
                                    Busqueda Avanzada
                                    <v-icon>mdi-tune</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="12">
                <v-row>
                    <v-col cols="12" md="12" >
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" md="8">
                <v-card>
                    <div class="indicadores-table">
                    <v-simple-table dense class="border">
                        <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-center" width="20px">N°</th>
                                <th class="text-left" width="540px">INDICADOR</th>
                                <th class="text-center" width="200px" v-if="tipoBusqueda==2">CURSO DE VIDA</th>
                                <th class="text-center" width="250px" v-if="tipoBusqueda==1">ESTRATEGIA</th>
                                <th class="text-center" width="20px">META</th>
                                <th class="text-center" width="20px">AVANCE</th>
                                <th class="text-center" width="30px" colspan="2">COBERTURA (%)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in indicadores" :key="item.ID_ACTIVIDAD" @click="rowClicked(item)">
                                <td class="text-center"><h5 style="text-button">{{ index + 1 }}</h5></td>
                                <td class="text-left"><a @click="mostrarFicha(item.ID_ACTIVIDAD)"><h5 style="text-button">{{ item.NOMBRE_ACTIVIDAD }}</h5></a></td>
                                <td class="text-center" v-if="tipoBusqueda==2"><h5 style="text-button">{{ item.CURSO_DE_VIDA }}</h5></td>
                                <td class="text-center" v-if="tipoBusqueda==1"><h5 style="text-button">{{ item.ESTRATEGIA }}</h5></td>
                                <td class="text-center"><h5 style="text-button">{{ item.DENOMINADOR }}</h5></td>
                                <td class="text-center"><a @click="getResumenIndicador(item.ID_ACTIVIDAD,item.NOMBRE_ACTIVIDAD)"><h5 style="text-button">
                                    <span v-if="programa==1 && (cursoVida == 1 || cursoVida == 2)">{{ item.JUNTOS }}</span>
                                    <span v-if="programa==2 && (cursoVida == 1 || cursoVida == 2)">{{ item.CUNAMAS }}</span>
                                    <span v-if="programa==3 && (cursoVida == 1 || cursoVida == 2)">{{ parseInt(item.JUNTOS) + parseInt(item.CUNAMAS) }}</span>
                                    <span v-if="(cursoVida != 1 && cursoVida != 2) || ((cursoVida == 1 || cursoVida == 2) && (programa!=1 && programa!=2 && programa!=3))">{{ item.NUMERADOR }}</span>
                                    </h5></a></td>
                                <td style="text-align: center" v-if="item.DENOMINADOR>0">
                                    <h5 style="text-button" >{{ Math.round((item.NUMERADOR / item.DENOMINADOR) * 1000) / 10 }}</h5>                                            
                                </td>
                                <td style="text-align: center" v-else>
                                    <h5 style="text-button" >0 %</h5>                                            
                                </td>
                                <td style="vertical-align: center" v-if="item.DENOMINADOR>0">
                                        <i v-if="mes.length == 0 && Math.round((item.NUMERADOR / item.DENOMINADOR) * 100) < (meses.length * 8.33) * 0.75" class="mdi mdi-checkbox-blank-circle red--text mdi-24px"></i>
                                        <i v-if="mes.length == 0 && Math.round((item.NUMERADOR / item.DENOMINADOR) * 100) >= (meses.length * 8.33) * 0.75 && Math.round((item.NUMERADOR / item.DENOMINADOR) * 100) < (meses.length * 8.33) * 0.80" class="mdi mdi-checkbox-blank-circle yellow--text mdi-24px"></i>
                                        <i v-if="mes.length == 0 && Math.round((item.NUMERADOR / item.DENOMINADOR) * 100) >= (meses.length * 8.33) * 0.80" class="mdi mdi-checkbox-blank-circle green--text mdi-24px"></i>
                                        <i v-if="mes.length > 0 && Math.round((item.NUMERADOR / item.DENOMINADOR) * 100) < (mes.length * 8.33) * 0.75 " class="mdi mdi-checkbox-blank-circle red--text mdi-24px"></i>
                                        <i v-if="mes.length > 0 && Math.round((item.NUMERADOR / item.DENOMINADOR) * 100) >= (mes.length * 8.33) * 0.75 && Math.round((item.NUMERADOR / item.DENOMINADOR) * 100) < (mes.length * 8.33) * 0.80" class="mdi mdi-checkbox-blank-circle yellow--text mdi-24px"></i>
                                        <i v-if="mes.length > 0 && Math.round((item.NUMERADOR / item.DENOMINADOR) * 100) >= (mes.length * 8.33) * 0.80" class="mdi mdi-checkbox-blank-circle green--text mdi-24px"></i>
                                </td>
                                <td style="text-align: center" v-else>
                                    <i class="mdi mdi-checkbox-blank-circle red--text mdi-24px"></i>                                           
                                </td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" md="4" v-if="tendencia != null" >
                <v-card
                    class="mx-auto text-center"
                    max-width="600" v-if="renderComponent4"
                >
                    <v-card-text>
                    <v-sheet color="rgba(0, 0, 0, .12)">
                        <Multiple :serie="this.tendencia.series" :numerador="this.tendencia.numerador" :avance="this.tendencia.avance" :titulo="this.tituloTendencia"></Multiple>
                    </v-sheet>
                    </v-card-text>
                </v-card>
                <br>
                <v-card
                    class="mx-auto text-center"
                    max-width="600" v-if="renderComponent4"
                >
                    <v-card-text>
                    <v-sheet color="rgba(0, 0, 0, .12)">
                        <MultipleA :serie="this.tendenciaAcumulada.series" :numerador="this.tendenciaAcumulada.numerador" :avance="this.tendenciaAcumulada.avance" :titulo="this.tituloTendencia"></MultipleA>
                    </v-sheet>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        
    </v-container>
</template>

<script>

import CursosVidasResource from '@/apis/cursoVida';
const cursosVidasResource = new CursosVidasResource()
import CargasResource from '@/apis/cargas';
const cargasResource = new CargasResource()

import axios from 'axios';

export default {
  name: "Indicadores",
  data: () => ({
      page: {
      title: "Indicadores",
      icon: "mdi-adjust",
    },
    breadcrumbs: [
      {
        text: "Tablero de Mando",
        disabled: false,
        to: "/"
      },
      {
        text: "Resumen",
        disabled: true
      }
    ],
    overlay:false,
    fechaActual: new Date(),
    mesActual: 1,
    mesActual1: 1,
    dialog: false,
    dialog1: false,
    dialog2: false,
    tabla: [],
    unidades: [],
    reporte: 0,
    indicadores: [],
    anios: [],
    anio: null,
    mes: [],
    ris: [],
    programa: '',
    programas: [
      {
        Id: 1,
        Nombre: 'JUNTOS'
      },
      {
        Id: 2,
        Nombre: 'CUNAMAS'
      },
      {
        Id: 3,
        Nombre: 'JUNTOS Y CUNAMAS'
      }],
    riss: [],
    subregiones: [
      {
        Id: 1,
        Nombre: 'CAJAMARCA'
      },
      {
        Id: 2,
        Nombre: 'CHOTA'
      },
      {
        Id: 3,
        Nombre: 'CUTERVO'
      },
      {
        Id: 4,
        Nombre: 'JAEN'
      }],
    redesClas: [],
    redClas: [],
    clases: [],
    clas: [],
    establecimientosClas: [],
    establecimientoClas: [],
    puertaEntrada: [],
    puertasEntrada: [],
    zonaSanitaria: [],
    zonasSanitarias: [],
    vinculado: [],
    vinculados: [],
    renderComponent: true,
    status(status) {
      const statusMap = {
        4: 'info',
        1: 'success',
        2: 'warning',
        3: 'danger'
      }
      return statusMap[status]
    },
    datosIndicador: [],
    ficha: null,
    redes: [],
    red: [],
    microredes: [],
    microred: [],
    establecimientos: [],
    establecimiento: [],
    subregion:[],
    redesSubregion: [],
    redSubregion: [],
    microRedesSubRegion: [],
    microredSubregion: [],
    establecimientosSubRegion: [],
    establecimientoSubRegion: [],
    provincias: [],
    provincia: '',
    distrito: '',
    distritos: [],
    cursosVidas: [],
    cursoVida: 1,
    estrategias: [],
    estrategia: 1,
    grupoEtareo: 0,
    gruposEtareos: [],
    nroIndicador: 0,
    renderComponent4: true,
    search: {
        categoria: [],
        unidad: [],
        mes: '',
        anio: 2022,
        red: [],
        microred: [],
        establecimiento: [],
        estrategia: []
      },
    ambito: 1,
    tipoBusqueda: 1,
    paqueteIntegral: false,
    ambitos:  [
        {
            id: 1,
            nombre: 'Administrativo'
        },
        {
            id: 2,
            nombre: 'Geografico'
        },
        {
            id: 3,
            nombre: 'RIS'
        },
        {
            id: 4,
            nombre: 'Subregion'
        }
    ],
    mesesIndicador: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
    ],
    tituloIndicadorGrafico: '',
    tituloTendencia: null,
    idTendencia: null,
    tendencia: null,
    tituloTendenciaAcumulada: null,
    tendenciaAcumulada: null,
    meses: [
    ],
    mesesTemp2: [
      {
        Id: 1,
        Nombre: 'Enero'
      },
      {
        Id: 2,
        Nombre: 'Febrero'
      },
      {
        Id: 3,
        Nombre: 'Marzo'
      },
      {
        Id: 4,
        Nombre: 'Abril'
      },
      {
        Id: 5,
        Nombre: 'Mayo'
      },
      {
        Id: 6,
        Nombre: 'Junio'
      },
      {
        Id: 7,
        Nombre: 'Julio'
      },
      {
        Id: 8,
        Nombre: 'Agosto'
      },
      {
        Id: 9,
        Nombre: 'Septiembre'
      },
      {
        Id: 10,
        Nombre: 'Octubre'
      },
      {
        Id: 11,
        Nombre: 'Noviembre'
      },
      {
        Id: 12,
        Nombre: 'Diciembre'
      }
    ],
    mesesTemp3: [
        { id: 1, name: 'Enero' },
        { id: 2, name: 'Febrero' },
        { id: 3, name: 'Marzo' },
        { id: 4, name: 'Abril' },
        { id: 5, name: 'Mayo' },
        { id: 6, name: 'Junio' },
        { id: 7, name: 'Julio' },
        { id: 8, name: 'Agosto' },
        { id: 9, name: 'Septiembre' },
        { id: 10, name: 'Octubre' },
        { id: 11, name: 'Noviembre' },
        { id: 12, name: 'Diciembre' },
    ],
    categorias: []
  }),
  components: {
    HMultiple: () => import('./dashboards/Graficos/Multiple/HMultiple'),
    Multiple: () => import('./dashboards/Graficos/Multiple/MultipleN'),
    MultipleA: () => import('./dashboards/Graficos/Multiple/MultipleA'),
  },
  mounted() {
    this.cargarCurso()
  },
  created() {
    this.cargarCurso()
    this.getRedes()
    this.getAnios()
    this.getMicroRedes()
    this.getRedesSubRegion()
    this.getMicroRedesSubRegion()  
    this.getEstablecimientosSubRegion()
    this.getProvincias()
    this.getDistritos()
    this.getRis()
    this.getZonaSanitaria()
    this.getPuertasEntrada()
    this.getPuestoVinculado()
    this.getEstablecimientos()
    this.getCursosVida()
    this.getEstrategias()
    this.getGrupoEtareo()    
    this.getRedesClas()
    this.getClass()
    this.getEstablecimientoClas()
  },
  methods: {
    
    async getAnios(){
      await cargasResource.fetchAnios().then(response => {
          this.anios = response
      })
      this.getAnio()
    },
    async getAnio(){
      await cargasResource.fetchAnioMax().then(response => {
          const anio = response
          this.anio = anio.toString()
      })
      this.getMeses()
    },
    async getMes(){
      await cargasResource.fetchMesMax(this.anio).then(response => {
          let mes = response
          this.mesActual = mes;
          this.mesActual1 = mes-1;
      })
    },
    async getMeses(){
      await cargasResource.fetchMeses(this.anio).then(response => {
          let meses = response
          this.meses = []
          for (var i = 0; i < meses.length; i++) {
            let cant = parseInt(meses[i])
            this.meses.push(this.mesesTemp2.find(x => x.Id === cant));
          }
      })
        this.getIndicador()
    },
    semaforo(num){
      if (num>=0.9) {
        return 'mdi mdi-checkbox-blank-circle green--text'
      } else if (num<0.9 && num>=0.75) {
        return 'mdi mdi-mdi mdi-triangle orange--text'
      }else if (num<0.75) {
        return 'mdi mdi-rotate-135 mdi-checkbox-blank red--text'
      }
    },
    cargarCurso(){
        if(this.$store.state.curso != undefined){
            if(this.$store.state.curso != 1){
            this.cursoVida = this.$store.state.curso
            }
            if(this.$store.state.grupo != 0){
            this.grupoEtareo = this.$store.state.grupo
            }
        }
    },
    async getRedes(){
        //await axios.get('http://tablero.test/api/redes',{
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/redes',{
          params: {
              unidadEjecutora: this.unidadEjecutora,
          }
      }).then(response => {
          this.redes = response.data
      })
    },async getRedesClas(){
        //await axios.get('http://tablero.test/api/class',{
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/clas/redes').then(response => {
          this.redesClas = response.data
      })
    },
    async getClass(){
        //await axios.get('http://tablero.test/api/class',{
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/clas/clas',{
        params: {
          red: this.redClas,
        }
      }).then(response => {
        this.clases = response.data
      })
    },
    async getEstablecimientoClas(){
      await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/clas/establecimientos',{
        params: {
            red: this.redClas,
          clas: this.clas,
        }
      }).then(response => {
        this.establecimientosClas = response.data
      })
    },
    mostrarFiltros(){
        this.dialog2 = true
    },
    async mostrarFicha(id){
       // await axios.get('http://tablero.test/api/fichas/'+id).then(response => {
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/fichas/'+id).then(response => {
          this.ficha = response.data
        })
        this.dialog = true
    },
    async getRedesSubRegion(){
        //await axios.get('http://tablero.test/api/redesSubRegion',{
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/redesSubRegion',{
          params: {
                SubRegion: this.subregion,
          }
      }).then(response => {
          this.redesSubregion = response.data
      })
    },
    async getMicroRedesSubRegion(){
        //await axios.get('http://tablero.test/api/microredesSubRegion',{
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/microredesSubRegion',{
          params: {
                SubRegion: this.subregion,
                redesSubregion: this.redSubregion,
          }
      }).then(response => {
          this.microRedesSubRegion = response.data
      })
    },
    async getEstablecimientosSubRegion(){
        //await axios.get('http://tablero.test/api/establecimientosSubRegion',{
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/establecimientosSubRegion',{
          params: {
                SubRegion: this.subregion,
                redesSubregion: this.redSubregion,
                microRedesSubRegion: this.microredSubregion
          }
      }).then(response => {
          this.establecimientosSubRegion = response.data
      })
    },
    async getMicroRedes(){
        //await axios.get('http://tablero.test/api/microredes',{
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/microredes',{
          params: {
              unidadEjecutora: this.unidadEjecutora,
              red: this.red,
          }
      }).then(response => {
          this.microredes = response.data
      })
    },
    async getEstablecimientos(){
        //await axios.get('http://tablero.test/api/establecimientos',{
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/establecimientos',{
          params: {
              unidadEjecutora: this.unidadEjecutora,
              red: this.red,
              microred: this.microred,
              tipoBusqueda: this.ambito,
              Provincia: this.provincia,
              distrito: this.distrito
          }
      }).then(response => {
          this.establecimientos = response.data
      })
    },
    getCursosVida(){
      cursosVidasResource.fetchCursosVidas().then(response => {
            this.cursosVidas = response
      })
    },
    async getEstrategias(){
        //await axios.get('http://tablero.test/api/estrategiasSanitarias')
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/estrategiasSanitarias')
      .then(response => {
            this.estrategias = response.data
        })
    },
    async getProvincias(){
        //await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/provincias')
        await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/provincias')
      .then(response => {
            this.provincias = response.data
        })
    },
    async getDistritos(){
        //await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/distritos',{
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/distritos',{
            params: {
                Provincia: this.provincia,
            }
        })
      .then(response => {
            this.distritos = response.data
        })
    },
    async getRis(){
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/ris')
        .then(response => {
            this.riss = response.data
        })
    },
    async getZonaSanitaria(){
        /*await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/zonaSanitaria',{
        //await axios.get('http://tablero.test/api/zonaSanitaria',{
            params: {
                ris: this.ris,
            }
        })
      .then(response => {
            this.zonasSanitarias = response.data
        })*/
       await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/zonas?',{
            params: {
                ris: this.ris,
            }
       })
      .then(response => {
            this.zonasSanitarias = response.data
        })
    },
    async getPuertasEntrada(){
        /*await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/puertasEntrada',{
        //await axios.get('http://tablero.test/api/puertasEntrada',{
            params: {
                ris: this.ris,
                zonaSanitaria: this.zonaSanitaria
            }
        })
      .then(response => {
            this.puertasEntrada = response.data
        })*/
       await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/puertas?',{
            params: {
                ris: this.ris,
                zona: this.zonaSanitaria
            }
       })
      .then(response => {
            this.puertasEntrada = response.data
        })
    },
    async getPuestoVinculado(){
        //await axios.get('http://tablero.test/api/vinculados',{
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/vinculados',{
            params: {
                ris: this.ris,
                zona: this.zonaSanitaria,
                puerta: this.puertaEntrada
            }
        })
      .then(response => {
            this.vinculados = response.data
        })
    },
    async getGrupoEtareo(){
      await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/subcursosVidas')
      //await axios.get('http://tablero.test/api/subcursosVidas')
      .then(response => {
            this.gruposEtareos = response.data
        })
    },
    async getTendencia(id){
        let est = ''
        if(this.ambito === 4){
            est = this.establecimientoSubRegion
        }
        else{
            est = this.establecimiento
        }
        //await axios.get('http://tablero.test/api/indicadorTendencia2/'+id,{
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/indicadorTendencia2/'+id,{
            params: {
                anio: this.anio,
                red: this.red,
                microred: this.microred,
                subRegion: this.subregion,
                redSubRegion: this.redSubregion,
                microredSubRegion: this.microredSubregion,
                Provincia: this.provincia,
                distrito: this.distrito,
                establecimiento: est,
                curso: this.cursoVida,
                estrategia: this.estrategia,
                tipoBusqueda: this.tipoBusqueda,
                ambito: this.ambito,
                grupo: this.grupoEtareo,
                paquete: this.paqueteIntegral,
                ris: this.ris,
                zonaSanitaria: this.zonaSanitaria,
                puertaEntrada: this.puertaEntrada,
                vinculado: this.vinculado,
                clas: this.clas,
                redClas: this.redClas,
                establecimientoClas: this.establecimientoClas
            }
        })
      .then(response => {
            this.tendencia = response.data
            this.forceRerender4()
        })
    },
    async getTendenciaAcumulada(id){
        let est = ''
        if(this.ambito === 4){
            est = this.establecimientoSubRegion
        }
        else{
            est = this.establecimiento
        }
        //await axios.get('http://tablero.test/api/indicadorTendenciaAcumulada2/'+id,{
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/indicadorTendenciaAcumulada2/'+id,{
            params: {
                anio: this.anio,
                red: this.red,
                microred: this.microred,
                subRegion: this.subregion,
                redSubRegion: this.redSubregion,
                microredSubRegion: this.microredSubregion,
                Provincia: this.provincia,
                distrito: this.distrito,
                establecimiento: est,
                curso: this.cursoVida,
                estrategia: this.estrategia,
                tipoBusqueda: this.tipoBusqueda,
                ambito: this.ambito,
                grupo: this.grupoEtareo,
                paquete: this.paqueteIntegral,
                ris: this.ris,
                zonaSanitaria: this.zonaSanitaria,
                puertaEntrada: this.puertaEntrada,
                vinculado: this.vinculado,
                clas: this.clas,
                redClas: this.redClas,
                establecimientoClas: this.establecimientoClas
            }
        })
      .then(response => {
            this.tendenciaAcumulada = response.data
            console.log(this.tendenciaAcumulada)
            this.forceRerender4()
        })
    },
    async getIndicador(){

    },
    async getIndicadorBoton(){
        this.overlay = true
        let est = ''
        if(this.ambito === 4){
            est = this.establecimientoSubRegion
        }
        else{
            est = this.establecimiento
        }
        //await axios.get('http://tablero.test/api/indicadores', {
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/indicadores', {
          params: {
              mes: this.mes,
              anio: this.anio,
              red: this.red,
              microred: this.microred,
              subRegion: this.subregion,
              redSubRegion: this.redSubregion,
              microredSubRegion: this.microredSubregion,
              Provincia: this.provincia,
              distrito: this.distrito,
              establecimiento: est,
              curso: this.cursoVida,
              estrategia: this.estrategia,
              tipoBusqueda: this.tipoBusqueda,
              ambito: this.ambito,
              grupo: this.grupoEtareo,
              paquete: this.paqueteIntegral,
              ris: this.ris,
              zonaSanitaria: this.zonaSanitaria,
              puertaEntrada: this.puertaEntrada,
              vinculado: this.vinculado,
              redClas: this.redClas,
              clas: this.clas,
              establecimientoClas: this.establecimientoClas
          }
      }).then(response => {
            this.indicadores = response.data
            this.forceRerender()
            this.overlay = false
      })
    },
    forceRerender() {
        // Remove my-component from the DOM
        this.renderComponent = false;

        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent = true;
        });
    },
    forceRerender3() {
        // Remove my-component from the DOM
        this.renderComponent3 = false;

        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent3 = true;
        });
    },
    forceRerender4() {
        // Remove my-component from the DOM
        this.renderComponent4 = false;

        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent4 = true;
        });
    },
    async getResumenIndicador(id,nombre){
        this.tituloIndicadorGrafico = nombre
        //await axios.get('http://tablero.test/api/indicadoresEstablecimiento/'+id,{
        await axios.get('https://sir.diresacajamarca.gob.pe:8004/api/indicadoresEstablecimiento/'+id,{
            params: {
                mes: this.mes,
                anio: this.anio,
                establecimiento: this.establecimiento,
                red: this.red,
                microred: this.microred,
                ambito: this.ambito,
                Provincia: this.provincia,
                distrito: this.distrito,
                subRegion: this.subregion,
                redSubRegion: this.redSubregion,
                microredSubRegion: this.microredSubregion,
                ris: this.ris,
                zonaSanitaria: this.zonaSanitaria,
                puertaEntrada: this.puertaEntrada,
                vinculado: this.vinculado,
                redClas: this.redClas,
                clas: this.clas,
                establecimientoClas: this.establecimientoClas
            }
        }).then(response => {
            this.datosIndicador = response.data
            this.dialog1 = true
            this.forceRerender()
        })
    },
    updateClas(){
      this.getEstablecimientoClas()
    },
    updateRedClas(){
      this.getClass()
    },
    updateEstablecimientoClas(){

    },
    updateRis(){
        this.zonaSanitaria = []
        this.puertaEntrada = []
        this.vinculado = []
        this.getZonaSanitaria()
        this.getPuertasEntrada()
        this.getPuestoVinculado()
        this.getIndicador()
    },
    updateZonaSanitaria(){
        this.puertaEntrada = []
        this.vinculado = []
        this.getPuertasEntrada()
        this.getPuestoVinculado()
         this.getIndicador()
    },
    updatePuertaEntrada(){
        this.vinculado = []
        this.getPuestoVinculado()
         this.getIndicador()
    },
    updateAmbito(){
        this.establecimientos = []
        this.getEstablecimientos()
         this.getIndicador()
    },
    updateRed(){
      this.microred = []
      this.establecimiento = []
      this.getMicroRedes();
      this.getEstablecimientos();
      this.getIndicador()
    },
    updateMicroRed(){
      this.establecimiento = []
      this.getEstablecimientos();
      this.getIndicador()
    },
    updateSubRegion(){
      this.redSubregion = []
      this.microredSubregion = []
      this.establecimientoSubRegion = []
      this.getRedesSubRegion();
      this.getMicroRedesSubRegion();
      this.getEstablecimientosSubRegion();
      this.getIndicador()
    },
    updateRedSubRegion(){
      this.microredSubregion = []
      this.establecimientoSubRegion = []
      this.getMicroRedesSubRegion();
      this.getEstablecimientosSubRegion();
      this.getIndicador()
    },
    updatemicroredSubregion(){
      this.establecimientoSubRegion = []
      this.getEstablecimientosSubRegion();
      this.getIndicador()
    },
    updateEstablecimientoSubregion(){
        this.getIndicador();
    },
    updateEstablecimiento(){
        this.getIndicador();
    },
    updateMeses(){
        this.getIndicador();
    },
    updateCursoVida(){
        this.getIndicador();
    },
    updateEstrategia(){
        this.getIndicador();
    },
    updateAnio(){
        this.getIndicador();
        this.getMeses();
    },
    updateProvincia(){
        this.getDistritos()
        this.establecimiento = []
        this.getEstablecimientos()
        this.getIndicador()
    },
    updateDistrito(){
        this.establecimiento = []
        this.getEstablecimientos()
        this.getIndicador()
    },
    updateSubCursoVida(){
        this.getIndicador()
    },
    updateTipoBusqueda(){
        this.getIndicador()
    },
    updatePaquete(){
        this.getIndicador()
    },
    rowClicked(item){
        this.tituloTendencia = item.NOMBRE_ACTIVIDAD
        this.idTendencia = item.ID_ACTIVIDAD
        this.getTendencia(item.ID_ACTIVIDAD)
        this.getTendenciaAcumulada(item.ID_ACTIVIDAD)
    }

  }
};
</script>

<style scoped>
 .indicadores-header {
     position: relative;
 }

 .indicadores-header-logo {
     display: flex;
     justify-content: flex-start;
     align-items: center;
     overflow: visible;
 }

 .indicadores-header h1 {
     text-align: center;
     margin: 0;
 }

 @media (min-width: 960px) {
     .indicadores-header h1 {
         position: absolute;
         left: 50%;
         top: 50%;
         transform: translate(-50%, -50%);
         width: max-content;
         max-width: calc(100% - 32px);
         z-index: 1;
     }
 }

 .indicadores-logo {
     width: 100% !important;
     max-width: 394px !important;
     height: auto !important;
     max-height: 75px !important;
     object-fit: contain;
     display: block;
 }

 .indicadores-table {
     width: 100%;
     overflow-x: auto;
     -webkit-overflow-scrolling: touch;
 }

 .indicadores-table .v-data-table__wrapper {
     overflow-x: auto;
     -webkit-overflow-scrolling: touch;
 }

 .indicadores-table table {
     min-width: 1100px;
     table-layout: auto;
 }

 .indicadores-table th,
 .indicadores-table td {
     white-space: nowrap;
 }

 .indicadores-table th.text-left,
 .indicadores-table td.text-left {
     white-space: normal;
     min-width: 360px;
 }

 @media (max-width: 600px) {
     .indicadores-logo {
         max-height: 56px !important;
     }
 }
</style>
